import { formatPlanDateRange } from '../../../../../../utils/utils'
import { SipPlanMode } from '../../api/types'

type SipPlansListEmptyStateProps = {
  planMode: SipPlanMode
  planSnapshotDate?: number | null
  planDurationInMonths?: number | null
}

const SIP_LIST_EMPTY_STATE_CONFIG: Record<
  SipPlanMode,
  { illustrationSrc?: string; periodLabelClassName: string }
> = {
  [SipPlanMode.YOUR_PLAN]: {
    illustrationSrc: '/images/allocation/plans-empty-state-allocation.png',
    periodLabelClassName: 'text-[13px] font-[400] text-[#7048AC]'
  },
  [SipPlanMode.IDEAL_SIPS]: {
    periodLabelClassName: 'text-[13px] font-[400] text-[#2e8ae5]'
  }
}

export function SipPlansListEmptyState({
  planMode,
  planSnapshotDate,
  planDurationInMonths
}: SipPlansListEmptyStateProps) {
  const emptyStateConfig = SIP_LIST_EMPTY_STATE_CONFIG[planMode]
  const planMonthRangeLabel = planSnapshotDate
    ? formatPlanDateRange(planSnapshotDate, planDurationInMonths ?? 1).replace(/ plan$/, '')
    : ''

  return (
    <div className="bg-white px-5 pt-8 pb-12 h-[600px] flex items-center">
      <div className="flex flex-col gap-7 max-w-[279px]">
        {emptyStateConfig.illustrationSrc ? (
          <div className="flex">
            <img
              src={emptyStateConfig.illustrationSrc}
              alt=""
              className="h-[184px] w-[243px] object-contain"
            />
          </div>
        ) : null}

        <div className="flex flex-col gap-5">
          {planMonthRangeLabel.length > 0 ? (
            <div className={emptyStateConfig.periodLabelClassName}>{planMonthRangeLabel}</div>
          ) : null}

          <div className="flex flex-col gap-5">
            <div className="text-[22px] font-[500] leading-[130%] text-[#232323]">
              All your SIPs are already in great shape
            </div>
            <div className="max-w-[259px] text-[13px] font-[400] leading-[140%] text-[#6A6E6E]">
              No changes are needed this month. We&apos;ll review it again next month to make sure it
              stays that way.
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
